import React from "react";
import InfiniteScrollTrigger from "components/infinite-scroll/InfiniteScrollTrigger";
import { skeletonGenerator } from "components/infinite-scroll/helpers";
import ProgramSkeleton from "components/infinite-scroll/skeletons/ArticleSkeleton";

const MainContentList = ({
  selectedItems,
  setSelectedItems,
  items,
  isLoadingNextPage,
  hasMoreItems,
  getNextPage,
  page,
  setPage,
  cardComponent,
}) => {
  return (
    <div className="w-full h-full overflow-y-auto bg-slate-50 p-6 sm:p-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 w-full">
          {items.map((item) => {
            const isSelected = selectedItems.find((i) => i.id === item.id);

            return (
              <div
                key={item.id}
                className={`relative rounded-3xl transition-all duration-200 cursor-pointer ${
                  isSelected
                    ? "ring-4 ring-indigo-500 shadow-md scale-[1.02]"
                    : "hover:scale-[1.01]"
                }`}
              >
                {isSelected && (
                  <span className="absolute top-3 right-3 z-30 px-2.5 py-1 rounded-full text-[10px] font-bold bg-indigo-600 text-white shadow-md">
                    Ընտրված է
                  </span>
                )}
                {React.cloneElement(cardComponent, {
                  item,
                  isSelected,
                  onCardClick: () =>
                    isSelected
                      ? setSelectedItems(
                          selectedItems.filter((i) => i.id !== item.id),
                        )
                      : setSelectedItems([...selectedItems, item]),
                })}
              </div>
            );
          })}
        </div>

        {isLoadingNextPage && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 w-full mt-6">
            {skeletonGenerator(<ProgramSkeleton />)}
          </div>
        )}

        <InfiniteScrollTrigger
          isLoading={isLoadingNextPage}
          hasMoreItems={hasMoreItems}
          callback={getNextPage}
          page={page}
          setPage={setPage}
        />
      </div>
    </div>
  );
};

export default MainContentList;
